module.exports = __webpack_public_path__ + "img/how-color.4dd11409.png";